import React from "react";
import PropTypes from "prop-types";
import Styles from "./Styles";

const SectionTitleArea = ({ title, depth, leftExtra, rightExtra }) => {
  const returnDepth = () => {
    switch (depth) {
      case "depth2":
        return <h2 className='page-tit-2'>{title}</h2>;
      case "depth3":
        return <h3 className='page-tit-3'>{title}</h3>;
      case "none":
        return <p className='page-tit-p'>{title}</p>;
      default:
        return <h1 className='page-tit-1'>{title}</h1>;
    }
  };
  return (
    <Styles className='section-tit-area'>
      <div className='extra-area left'>
        {returnDepth()}
        {leftExtra}
      </div>
      <div className='extra-area right'>{rightExtra}</div>
    </Styles>
  );
};

SectionTitleArea.propTypes = {
  title: PropTypes.string,
  depth: PropTypes.string,
};

SectionTitleArea.defaultProps = {
  title: null,
  depth: "depth1",
};

export default SectionTitleArea;
